// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { boolean, any } from "@altostra/type-validations/lib/primitives";

export const isAlloysPartnersAlloysIdResult = objectOf({
  is_installed: boolean,
  bridges: arrayOf(any),
});
